import axios from "axios";
import { fullAPIURL } from "../utils/requests";
import { responseStatusInterceptor } from "../utils/axios.utils";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

const loginAxios = axios.create({
  baseURL: `${fullAPIURL}/v2/auth`,
  headers: { "Content-Type": "application/json" },
  validateStatus: null,
});

loginAxios.interceptors.response.use(responseStatusInterceptor);

export async function loginWithCode(
  clientUuid: string,
  email: string,
  code: string,
) {
  const response = await loginAxios.post("/login-with-code", {
    clientUuid,
    email,
    code,
  });
  return response.data;
}

export async function generateCode(email: string, loginUrl?: string) {
  const response = await loginAxios.post("/generate-code", { email, loginUrl });
  return response.data;
}

export async function updatePassword(email: string, password: string) {
  const token = Cookies.get("ACCESS_TOKEN");

  if (!token) {
    throw new Error("No token found");
  }

  const sub = jwtDecode(token)?.sub;

  const response = await axios.patch(
    `${fullAPIURL}/v2/user/user/${sub}`,
    { email, password },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
}
